export const normalizeName = (name: string): string => {
  return name.split(' ').reduce((acc: string, value: string) => {
    if (value !== 'null') {
      if (!!acc.length) {
        acc = `${acc} ${value}`;
      } else {
        acc = value;
      }
    }
    return acc;
  }, '');
};
